import type { Pods, Result } from "@/types";
import { AxiosError } from "axios";
import API from "./api";

export async function fetchPods(
	bearerToken: string,
): Promise<Result<Pods, Error | AxiosError>> {
	try {
		const response = await API.get("/pods", {
			headers: { Authorization: `Bearer ${bearerToken}` },
		});
		return [response.data, null];
	} catch (error) {
		if (error instanceof AxiosError) {
			return [null, error];
		}

		return [null, new Error("Unknown error")];
	}
}
